import(/* webpackMode: "eager", webpackExports: ["NotFoundUI"] */ "/app/apps/web/src/components/common/error/not-found.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureFlag"] */ "/app/apps/web/src/components/common/feature-flag/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardHighlightSection"] */ "/app/apps/web/src/components/dashboard/highlight-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YoutubePlayButton"] */ "/app/apps/web/src/components/dashboard/youtube-play-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterOverhaul"] */ "/app/apps/web/src/components/layout/left-sidebar/footer-overhaul.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventProgressionSection"] */ "/app/apps/web/src/components/special-offers/event-progression-section.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.18_@babel+core@7.28.5_@opentelemetry+api@1.8.0_react-dom@19.2.6_react@19.2.6__react@19.2.6_sass@1.79.4/node_modules/next/dist/client/image-component.js");
